<!--  -->
<template>
  <div class="friends-box">
      <div class="top-wrapper">
        <div class="head-title">{{ title }}</div>
      </div>
      <div class="friends-all-item">
        <div class="friends-item">
          <div class="friends-item-img">
            <img src="../../assets/friends/baiyunshan.png">
          </div>
          <div class="friends-item-name">
            广州白云山中一药业有限公司
          </div>
        </div>
        <div class="friends-item">
          <div class="friends-item-img">
            <img src="../../assets/friends/yaoke.png">
          </div>
          <div class="friends-item-name">
            广州兆科联发医药有限公司 
          </div>
        </div>
      </div>
      
    
  </div>
</template>

<script>



export default {
  name: '',
  data () {
    return {
      isActive: false,
      isShow: false,
      isCommit: false,
      title: '合作伙伴'
    }
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {

  }
}

</script>
<style lang='scss' scoped>
.friends-box {
 .top-wrapper {
      padding-bottom: 29px;
      text-align: left;
      .head-title {
        color: #333;
        font-size: 30px;
        line-height: 42px;
        font-weight: bold;
      }
    }
  
    .friends-all-item {
      display: flex;
      align-items: center;
      .friends-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        width: 300px;
        margin-right: 10px;

        .friends-item-img{
          width: 200px;
          height: 90px;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: max-content;
          }
        }

        .friends-item-name{
          font-size: 16px;
        }
      }
    }
 
}
</style>


// WEBPACK FOOTER //
// src/components/friendsBox/friendsBox.vue